<template>
  <v-btn
    class="primary-button"
    block
    color="primary"
    :disabled="disabled"
    elevation="0"
    :sls-element-id="slsElementId"
    @click="click"
    ><slot></slot
  ></v-btn>
</template>

<script>
export default {
  name: 'PrimaryButton',
  props: {
    click: {
      default: () => {},
      type: Function,
    },
    disabled: {
      type: Boolean,
    },
    slsElementId: {
      default: null,
      type: String,
    },
  },
}
</script>
<style lang="sass">
.primary-button
  height: 48px !important
  border-radius: 10px
  .v-btn__content
    font-size: 18px !important
  &.v-btn.v-btn--disabled.v-btn--has-bg
    background-color: $darkGrey !important
    color: white !important
</style>
